import React, { useCallback, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, useHistory } from "react-router-dom";
import { toast } from "react-toastify";
import Loading from "../LoadingError/Loading";
import Toast from "../LoadingError/Toast";
import MainPanel from "../main-panel/MainPanel";
import Message from "../LoadingError/Error";
import moment from "moment/moment";
import { blogAdd } from "../../Redux/Actions/BlogAction";
import { BLOG_CLEAR } from "../../Redux/Constants/BlogConstants";
import axios from "axios";
import { BASE_URL, PICTURE_URL } from "../../api/BaseConfig";
import { Box, Button, Checkbox, FormControl, FormLabel, Heading, Image, Input, Spinner, Text } from "@chakra-ui/react";

const ToastObjects = {
  pauseOnFocusLoss: false,
  draggable: false,
  pauseOnHover: false,
  autoClose: 2000,
};
//language
const AddBlogMain = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const languageList = [
    { id: 1, langKey: "AZ" },
    { id: 2, langKey: "GB" },
    { id: 3, langKey: "RU" },
  ];

  const [date, setDate] = useState(moment().format("YYYY-MM-DD"));
  const [photoUrl, setPhotoUrl] = useState([]);
  const [isFeatured, setIsFeatured] = useState(false);
  const [language, setLanguage] = useState([]);
  const [imageTitle, setImageTitle] = useState("");
  const [imageAlt, setImageAlt] = useState("");


  const onChangeDate = (e) => {
    const newDate = moment(new Date(e.target.value)).format("YYYY-MM-DD");
    setDate(newDate);
  };

  const handlePicture = (e) => {
    let data = new FormData();
    data.append("file", e, e.name);

    axios
      .post(BASE_URL + "/file", data, {
        headers: {
          accept: "application/json",
          "Accept-Language": "en-US,en;q=0.8",
          "Content-Type": `multipart/form-data; boundary=${data._boundary}`,
        },
      })
      .then((x) => {
        setPhotoUrl(x.data);
      })
      .catch((err) => alert(err));
  };

  const onHandleLangChange = useCallback((dataInfo) => {
    let languageList = {
      name: dataInfo.name,
      description: dataInfo.description,
      seoTitle: dataInfo.seoTitle,
      seoDescription: dataInfo.seoDescription,
      languageKey: dataInfo.lang,
    };
    setLanguage((ln) => [
      ...ln.filter(
        (l) => l.languageKey !== dataInfo.lang && l.languageKey !== ""
      ),
      languageList,
    ]);
  }, []);
  const blogCreate = useSelector((state) => state.blogAdd);
  const { loading, error, blog } = blogCreate;

  useEffect(() => {
    if (blog) {
      toast.success("Blog successfully added!", ToastObjects);
      dispatch({ type: BLOG_CLEAR });
      setDate();
      setIsFeatured(false);
      setPhotoUrl("");
      setImageTitle("");
      setImageAlt("");
    }
  }, [blog, dispatch]);

  const submitHandler = (e) => {
    e.preventDefault();
    try {
      dispatch(
        blogAdd({
          blogDate: date,
          photoUrl,
          // isFeatured,
          blogRecords: language,
          imageTitle,
          imageAlt,
        })
      );
      toast.success("Blog successfully added!", ToastObjects);
      setTimeout(() => {
        history.push("/blogs");
      }, 2000);
    } catch { }
  };
  return (
    <>
      <Toast />
      <Box maxW="1200px" mx="auto" p={4}>
        <form onSubmit={submitHandler}>
          <Box display="flex" justifyContent="space-between" alignItems="center" mb={4}>
            <Button
              as={Link}
              to="/blogs"
              colorScheme="red"
              variant="solid"
              _hover={{
                backgroundColor: "red.600",
                color: "white",
              }}
            >
              Go to blogs
            </Button>
            <Heading as="h2" size="lg" color="teal.600">
              Add Blog
            </Heading>
            <Button type="submit" colorScheme="teal">
              Publish Now
            </Button>
          </Box>

          <Box bg="white" p={6} shadow="md" borderRadius="lg">
            {error && <Message variant="alert-danger">{error}</Message>}
            {loading && <Spinner color="blue.500" size="lg" />}
            <Box mb={4}>
              <MainPanel
                mainLang={languageList}
                changeLang={onHandleLangChange}
                languageInfo={language}
              />
            </Box>

            <FormControl mb={4}>
              <FormLabel htmlFor="blog_date">Date</FormLabel>
              <Input
                type="date"
                id="blog_date"
                required
                value={date}
                onChange={onChangeDate}
              />
            </FormControl>

            <FormControl mb={4}>
              <FormLabel htmlFor="featured_price">Is Featured?</FormLabel>
              <Checkbox
                id="featured_price"
                isChecked={isFeatured}
                onChange={(e) => setIsFeatured(e.target.checked)}
              >
                <Text fontSize="lg">Featured Blog</Text>
              </Checkbox>
            </FormControl>

            <FormControl mb={4}>
              <Input
                type="file"
                required
                onChange={(e) => handlePicture(e.target.files[0])}
              />
              <FormLabel>Images</FormLabel>
              {photoUrl && (
                <Box
                  mt={3}
                  width="300px"
                  height="250px"
                  overflow="hidden"
                  display="flex"
                  justifyContent="center"
                  alignItems="center"
                  bgcolor="lightgray" 
                >
                  <Image
                    src={PICTURE_URL + photoUrl}
                    alt="Uploaded Image"
                    style={{
                      maxWidth: "100%",
                      maxHeight: "100%",
                    }}
                  />
                </Box>
              )}

            </FormControl>
            <FormControl mb={4}>
              <FormLabel htmlFor="image_title">Image Title</FormLabel>
              <Input
                type="text"
                id="image_title"
                value={imageTitle}
                onChange={(e) => setImageTitle(e.target.value)}
                placeholder="Enter image title"
              />
            </FormControl>

            <FormControl mb={4}>
              <FormLabel htmlFor="image_alt">Image Alt Text</FormLabel>
              <Input
                type="text"
                id="image_alt"
                value={imageAlt}
                onChange={(e) => setImageAlt(e.target.value)}
                placeholder="Enter image alt text"
              />
            </FormControl>
          </Box>
        </form>
      </Box>
    </>
  );
};

export default AddBlogMain;
